import {ReactNode} from 'react';
import {Link} from '@shopify/hydrogen';
import classNames from 'classnames';

interface CursorPaginationLinkProps {
  cursor?: string;
  to: string;
  children: ReactNode;
}

const className = 'pagination__link pagination__nav';

export default function CursorPaginationLink({
  cursor,
  to,
  children,
  ...passThroughProps
}: CursorPaginationLinkProps) {
  return cursor ? (
    <Link to={to} className={className} {...passThroughProps}>
      {children}
    </Link>
  ) : (
    <button className={classNames(className, 'disabled')} disabled>
      {children}
    </button>
  );
}
